import * as React from 'react'

import { ReactBlocks } from 'app/helpers/Blocks'
import { observeLazyLoadedChildrenImages } from 'app/helpers/observer'
import SwarmbytesLayout from 'app/layouts/SwarmbytesLayout'
import { TPageData } from 'app/service/api/theme'

interface IProps {
  pageData: TPageData<'carebuzz'>
}

const SwarmbytesPage: React.FC<IProps> = ({ pageData }) => {
  React.useEffect(() => {
    observeLazyLoadedChildrenImages(document)
  })

  return (
    <SwarmbytesLayout>
      <ReactBlocks innerBlocks={pageData} withoutClientOnly />
    </SwarmbytesLayout>
  )
}

export default SwarmbytesPage
